export default __webpack_public_path__ + "static/mip-browser-481fd01cce4b40fb78fd697a05a2f3e5.png";